import '@/modules/cart'
import { CartItems, CartRemoveButton, QuantityInput } from '@/modules/cart'

if (document.getElementsByTagName('cart-items')) {
    customElements.define('cart-items', CartItems);
}

if (document.getElementsByTagName('cart-remove-button')) {
    customElements.define('cart-remove-button', CartRemoveButton);
}

if (document.getElementsByTagName('quantity-input')) {
    customElements.define('quantity-input', QuantityInput);
}

